import React, {Fragment} from "react";
import {Breadcrumb} from "react-bootstrap";

export const Page = (
  {
    title,
    breadcrumbs = undefined,
    children
  }: {
    title: string,
    breadcrumbs?: {
      title?: string
      parents?: {
        title: string,
        link: string
      }[]
    }
    children: React.ReactNode
  }) => {
  return <Fragment>
    {breadcrumbs !== undefined &&
      <Breadcrumb>
        {breadcrumbs.parents && breadcrumbs.parents.map(
          (parent, index) =>
            <Breadcrumb.Item key={index} href={parent.link}>{parent.title}</Breadcrumb.Item>)}
        <Breadcrumb.Item active>
          {breadcrumbs.title || title}
        </Breadcrumb.Item>
      </Breadcrumb>
    }
    <h1 className="text-center mt-4 mb-5">{title}</h1>
    {children}
  </Fragment>
}